module.exports = __webpack_public_path__ + "static/media/gmail.479ffb62.svg";